import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { ActionWithPayload } from "@obg/ngrx-utils";
import { TelemetryService } from "@obg/ngx.global";
import { Log, LoggingFactory } from "@obg/ngx.global.evo";
import { RouteAction } from "@obg/ngx.router";
import { buffer, filter, map, tap } from "rxjs/operators";

import { UI_INTERACTION_TYPE } from "../../ui-interaction/ui-interaction.action";
import { UiInteraction } from "../../ui-interaction/ui-interaction.model";
import { UiInteractionService } from "../../ui-interaction/ui-interaction.service";

@Injectable()
export class UiInteractionTelemetryEffect {
	uiInteractionTracking$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(UI_INTERACTION_TYPE.emit),
				map((x: ActionWithPayload<UiInteraction>) => x.payload),
				filter((interaction) => !this.uiInteractionService.getTrackingData(interaction)?.waitForNavigation),
				tap((interaction) => {
					const trackingData = this.uiInteractionService.getTrackingData(interaction);
					if (!trackingData) {
						this.logger.warn("uiInteractionTracking$", "Mapping not found.", interaction);
						return;
					}
					this.telemetryService.track({
						...trackingData,
						...interaction.data,
					});
				})
			),
		{ dispatch: false }
	);

	uiInteractionTrackingAfterNavigation$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(UI_INTERACTION_TYPE.emit),
				map((x: ActionWithPayload<UiInteraction>) => x.payload),
				filter((interaction) => !!this.uiInteractionService.getTrackingData(interaction)?.waitForNavigation),
				buffer(this.actions$.pipe(ofType(RouteAction.resolveEnd))),
				tap((interactions) => {
					interactions.forEach((interaction) => {
						const trackingData = this.uiInteractionService.getTrackingData(interaction);
						if (!trackingData) {
							this.logger.warn(
								"uiInteractionTrackingAfterNavigation$",
								"Mapping not found.",
								interaction
							);
							return;
						}
						this.telemetryService.track({
							...trackingData,
							...interaction.data,
						});
					});
				})
			),
		{ dispatch: false }
	);

	private logger: Log;

	constructor(
		private actions$: Actions,
		private telemetryService: TelemetryService,
		private uiInteractionService: UiInteractionService,
		logging: LoggingFactory
	) {
		this.logger = logging.get("uiInteractionTelemetryEffect");
	}
}
